import React, { useState } from "react";
import { Amplify, I18n } from "aws-amplify";

import {
  logo,
  triangle1Svg,
  triangle2Svg,
  triangle3Svg,
  triangle4Svg,
  triangle5Svg,
  triangle6Svg,
  triangle7Svg,
} from "../assets/images";
import { Mailto } from "../helpers/login/mailTo";

const loginLayout = (props) => {
  return (
    <>
      <img className="dm-portal-login-triangle-1" src={triangle1Svg} alt="" />
      <img className="dm-portal-login-triangle-2" src={triangle2Svg} alt="" />
      <img className="dm-portal-login-triangle-3" src={triangle3Svg} alt="" />
      <img className="dm-portal-login-triangle-4" src={triangle4Svg} alt="" />
      <img className="dm-portal-login-triangle-5" src={triangle5Svg} alt="" />
      <img className="dm-portal-login-triangle-6" src={triangle6Svg} alt="" />
      <img className="dm-portal-login-triangle-7" src={triangle7Svg} alt="" />

      <div className="dm-portal-login-box">
        <div style={{ marginLeft: "10%", marginTop: "10%", zIndex: 2 }}>
          <div>
            <img src={logo} width="135" alt="logo" />
          </div>
          {props.children}
        </div>
      </div>
      <div className="dm-portal-login-have-questions">
        <b>{I18n.get("¿Tienes dudas?")}</b> {I18n.get("Contáctanos a")}{" "}
        <Mailto
          email="soporte@datamart.cl"
          subject="Consulta sobre portal Datamart"
          body=""
        >
          soporte@datamart.cl
        </Mailto>
      </div>
    </>
  );
};

export default loginLayout;
